import { RouteComponentProps } from 'react-router-dom';
import BaseViewModel from './BaseViewModel';
import { BaseResponseCore, ErrorType, ErrorMessage } from './BaseResponse';
import { ConfirmBoxResult } from '../Control/index';
import { ConstantMessage } from '.';
import BaseComponentCore from './BaseComponentCore';
import SessionHelper from './SessionHelper';
import PermissionHelper from './PermissionHelper';
export default abstract class BaseComponent<T, U> extends BaseComponentCore<T, U> {

  /**
   * Checks if the current user can perform an action on the current page.
   * Automatically strips the /admin prefix from the URL before matching.
   * @param action 'CanCreate' | 'CanEdit' | 'CanDelete'
   * @param path Optional override path (e.g. '/category'). If not provided, uses current URL.
   */
  protected CanDo(action: 'CanCreate' | 'CanEdit' | 'CanDelete', path?: string): boolean {
    let routePath = path || window.location.pathname;
    // Strip known basename prefix (e.g. /admin)
    routePath = routePath.replace(/^\/admin/, '') || '/';
    return PermissionHelper.HasPermission(routePath, action);
  }

  ShowPageLoader(IsLoading: boolean, LabelText: string = "") {
    var model = this.state.Model as unknown as BaseViewModel;
    model.IsPageLoading = IsLoading;
    model.PageLoadingLabel = LabelText ? model.TableLoadingLabel : LabelText;
    this.UpdateViewModel();
  }

  ShowTableLoader(IsLoading: boolean, LabelText: string = "") {
    var model = this.state.Model as unknown as BaseViewModel;
    model.IsTableLoading = IsLoading;
    model.TableLoadingLabel = LabelText ? model.TableLoadingLabel : LabelText;
    this.UpdateViewModel();
  }



  // #region Toast message
  public ProcessResponseData(Response: BaseResponseCore<unknown>, ShowIsSuccessMessage: boolean = true) {

    if (Response.IsHttpError) {
      this.ShowToastMessage(
        Response.Message || `API request failed (HTTP ${Response.HttpStatus || '?'})`,
        ErrorType.Error,
      );
      return;
    }

    if (Response.IsSessionExpired) {
      SessionHelper.SetSession(null);
      this.ShowToastMessage("Your session is expired, please try to re-login", ErrorType.Error)
      var props2 = this.props as unknown as RouteComponentProps
      props2?.history?.push(ConstantMessage.LoginPagePath);
      return;
    }

    


    if (!ShowIsSuccessMessage && Response.IsSuccess) {
      return;
    }

    var allMessages: ErrorMessage[] = [];
    var mainMesageType = Response.IsSuccess ? ErrorType.Info : ErrorType.Warning;
    allMessages.push(new ErrorMessage(
      {
        ErrorType: mainMesageType,
        Message: Response.Message,
        AdditionInfo: undefined,
        FieldName: ""
      }));

    (Response.Errors || []).forEach(err => {
      allMessages.push(new ErrorMessage(
        {
          ErrorType: err.ErrorType,
          Message: err.Message,
          AdditionInfo: err.AdditionInfo,
          FieldName: err.FieldName
        }));
    });

    this.UpdateModelForToastMessage(allMessages);
  }

  private UpdateModelForToastMessage(AllMesages: ErrorMessage[] | ErrorMessage) {
    var tempArray: ErrorMessage[] = [];

    if (!Array.isArray(AllMesages)) {
      tempArray.push(AllMesages)
    }
    else {
      tempArray = AllMesages;
    }
    var model = this.state.Model as unknown as BaseViewModel;
    model.Messages = tempArray;
    this.UpdateViewModel();
  }

  public ShowToastMessage(Message: string, ErrorType: ErrorType) {
    var message = new ErrorMessage(
      {
        ErrorType: ErrorType,
        Message: Message,
        AdditionInfo: null,
        FieldName: ""
      })
    this.UpdateModelForToastMessage(message)
  }

  public OnToastEntered = (e: React.SyntheticEvent, reason: string, key: string) => {
    //alert('this is obsolate now')
    var model = this.state.Model as unknown as BaseViewModel;
    model.OnToastEntered(e, reason, key)
  }
  // #endregion

  //#region Conform Box
  public async ShowConfirmBox(Title: string, Message: string = ""): Promise<ConfirmBoxResult> {
    return this.ShowConfirmBoxDetail(Title, Message, ConstantMessage.DefaultConfirmBoxYesButtonText, ConstantMessage.DefaultConfirmBoxNoButtonText)
  }

  public async ShowConfirmBoxDetail(Title: string, Message: string, OkButtonText: string, CancelButtonText: string): Promise<ConfirmBoxResult> {

    return new Promise((resolve) => {
      var model = this.state.Model as unknown as BaseViewModel;
      model.ConfirmBoxTitle = Title;
      model.ConfirmBoxMessage = Message
      model.ConfirmBoxIsOpen = true;
      model.ConfirmBoxOkText = OkButtonText;
      model.ConfirmBoxCancelText = CancelButtonText;
      model.ConfirmBoxOnButtonClick = (ButtonClicked: string) => {
        model.ConfirmBoxIsOpen = false;
        var result = ConfirmBoxResult.Cancel;
        if (ButtonClicked === model.ConfirmBoxOkText) {
          result = ConfirmBoxResult.OK
        }
        this.UpdateViewModel();
        resolve(result)
        return result;

      }
      this.UpdateViewModel();
    })

  }

  //#region override base methods

  // componentDidMount() {    
  //   this.ClearForm();
  // }
  // //#region Abstract Methods
  // abstract ClearForm(): void

  // HandleClearButton = async () => {
  //   var result = await this.ShowConfirmBox("Clear!!", "Do you want to clear the form?");
  //   if (result === ConfirmBoxResult.OK) {
  //     this.ClearForm();
  //   }
  // }
  //#endregion

}
